import script from "./chart6.vue?vue&type=script&lang=ts&setup=true"
export * from "./chart6.vue?vue&type=script&lang=ts&setup=true"

import "./chart6.vue?vue&type=style&index=0&id=517f6234&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-517f6234"]])

export default __exports__